import type { NamePool } from "@/core/types.js";
export const mxNamePool: NamePool = {
  given: {
    male: ["José","Luis","Carlos","Juan","Miguel","Jorge","Roberto","Francisco","Antonio","Alejandro","Héctor","Arturo","Mario","Ricardo","Raúl","Eduardo","Gabriel","Hugo","Fernando","David"],
    female: ["María","Ana","Laura","Patricia","Claudia","Sandra","Rosa","Elena","Daniela","Gabriela","Verónica","Alejandra","Guadalupe","Isabel","Silvia","Adriana","Beatriz","Carmen","Alicia","Mónica"],
  },
  family: ["García","Martínez","López","González","Hernández","Pérez","Sánchez","Rodríguez","Flores","Torres","Ramírez","Morales","Díaz","Vásquez","Reyes","Jiménez","Gutiérrez","Ortiz","Castillo","Mendoza"],
};
